import { z } from "zod";

import { RegionEnum } from "../constants/application/applicant.enum";

const regionSchema = z.enum(RegionEnum, {
  error: () => "error:required",
});

export const isCanadianRegion = (
  region: RegionEnum | undefined | null | ""
) => {
  return regionSchema.safeParse(region).success;
};
